// src/components/admin/CreateCustomerModal.js
import React, { useState } from 'react';
import { X } from 'lucide-react';
import './createdealermodal.css';

function CreateCustomerModal({ 
  handleCreateUser, 
  setShowCreateCustomerModal,
  newUsername, setNewUsername,
  newEmail, setNewEmail,
  newMobile, setNewMobile,
  newPassword, setNewPassword,
  currentUserRole
}) {
  const [uniqueId, setUniqueId] = useState('');
  const [speedUnit, setSpeedUnit] = useState('km/h');
  const [distanceUnit, setDistanceUnit] = useState('km');
  const [altitudeUnit, setAltitudeUnit] = useState('meters');
  const [volumeUnit, setVolumeUnit] = useState('Liter');
  const [timezone, setTimezone] = useState('Asia/Kolkata');
  const [attributes, setAttributes] = useState([]);
const [devicePermissions, setDevicePermissions] = useState({});
const [userPermissions, setUserPermissions] = useState({});
  const addAttribute = () => {
    setAttributes([...attributes, { name: '', type: 'text' }]);
  };

  const removeAttribute = (index) => {
    setAttributes(attributes.filter((_, i) => i !== index));
  };

  const handleSubmit = (e) => {
    
    e.preventDefault();
    // Prepare data with preferences
    const customerData = {
      username: newUsername,
      email: newEmail,
      mobileNo: newMobile,
      password: newPassword,
      role: 'user', // Fixed role for customer
      uniqueId: uniqueId || undefined,
      speedUnit,
      distanceUnit,
      altitudeUnit,
      volumeUnit,
      timezone,
      attributes: attributes.length > 0 ? attributes : undefined,
      devicePermissions: Object.keys(devicePermissions).length > 0 ? devicePermissions : undefined,
userPermissions: Object.keys(userPermissions).length > 0 ? userPermissions : undefined,
    };
    
    
    handleCreateUser(e, customerData);
  };
  

  return (
    <div className="um-modal-overlay">
      <div className="um-modal-content" style={{ maxWidth: '700px' }}>
        <div className="um-modal-header">
          <h3>Add Customer</h3>
          <button type="button" className="um-close-icon" onClick={() => setShowCreateCustomerModal(false)}>
            <X size={20} />
          </button>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="um-form-section">
            <h4 className="um-section-title">Required</h4>
            
            <div className="um-form-grid">
              <div className="um-form-group">
                <label>Name *</label>
                <input 
                  type="text" 
                  value={newUsername}
                  onChange={(e) => setNewUsername(e.target.value)}
                  required 
                  className="um-input"
                />
              </div>

              <div className="um-form-group">
                <label>User ID *</label>
                <input 
                  type="text" 
                  value={uniqueId}
                  onChange={(e) => setUniqueId(e.target.value)}
                  required 
                  className="um-input"
                />
              </div>

              <div className="um-form-group">
                <label>Email *</label>
                <input 
                  type="email" 
                  value={newEmail}
                  onChange={(e) => setNewEmail(e.target.value)}
                  required 
                  className="um-input"
                />
              </div>

              <div className="um-form-group">
                <label>Mobile</label>
                <input 
                  type="text" 
                  value={newMobile}
                  onChange={(e) => setNewMobile(e.target.value)}
                  className="um-input"
                />
              </div>

              <div className="um-form-group">
                <label>Enter Password *</label>
                <input 
                  type="password" 
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required 
                  className="um-input"
                />
              </div>
            </div>
          </div>

          <div className="um-form-section">
            <h4 className="um-section-title">Preferences</h4>
            
            <div className="um-form-grid">
              <div className="um-form-group">
                <label>Speed Unit</label>
                <select value={speedUnit} onChange={(e) => setSpeedUnit(e.target.value)} className="um-select-full">
                  <option value="km/h">km/h</option>
                  <option value="mph">mph</option>
                  <option value="knots">knots</option>
                </select>
              </div>

              <div className="um-form-group">
                <label>Distance Unit</label>
                <select value={distanceUnit} onChange={(e) => setDistanceUnit(e.target.value)} className="um-select-full">
                  <option value="km">km</option>
                  <option value="miles">miles</option>
                  <option value="meters">meters</option>
                </select>
              </div>

              <div className="um-form-group">
                <label>Altitude Unit</label>
                <select value={altitudeUnit} onChange={(e) => setAltitudeUnit(e.target.value)} className="um-select-full">
                  <option value="meters">m</option>
                  <option value="feet">feet</option>
                </select>
              </div>

              <div className="um-form-group">
                <label>Volume Unit</label>
                <select value={volumeUnit} onChange={(e) => setVolumeUnit(e.target.value)} className="um-select-full">
                  <option value="Liter">Liter</option>
                  <option value="Gallon">Gallon</option>
                  <option value="ml">ml</option>
                </select>
              </div>

              <div className="um-form-group">
                <label>Time Zone</label>
                <select value={timezone} onChange={(e) => setTimezone(e.target.value)} className="um-select-full">
                  <option value="Asia/Kolkata">Asia/Kolkata</option>
                  <option value="UTC">UTC+0</option>
                  <option value="America/New_York">EST</option>
                </select>
              </div>

              <div className="um-form-group">
                <label>Language</label>
                <select className="um-select-full">
                  <option value="">Select Language</option>
                  <option value="en">English</option>
                  <option value="hi">Hindi</option>
                </select>
              </div>
            </div>
          </div>
          <div className="um-form-section">
  <h4 className="um-section-title">Permissions (Optional)</h4>
  
  <div className="um-form-grid">
    <label>
      <input type="checkbox" 
        checked={devicePermissions?.create} 
        onChange={(e) => setDevicePermissions({...devicePermissions, create: e.target.checked})}
      /> Can Create Devices
    </label>
    
    <label>
      <input type="checkbox" 
        checked={userPermissions?.create} 
        onChange={(e) => setUserPermissions({...userPermissions, create: e.target.checked})}
      /> Can Create Users
    </label>
  </div>
</div>

          <div className="um-form-section">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h4 className="um-section-title">Attributes</h4>
              <button type="button" className="um-btn-sm um-btn-secondary" onClick={addAttribute}>
                + ADD
              </button>
            </div>

            {attributes.map((attr, index) => (
              <div key={index} style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
                <input 
                  type="text" 
                  placeholder="Attribute Name"
                  value={attr.name}
                  onChange={(e) => {
                    const newAttrs = [...attributes];
                    newAttrs[index].name = e.target.value;
                    setAttributes(newAttrs);
                  }}
                  className="um-input"
                  style={{ flex: 1 }}
                />
                <select 
                  value={attr.type}
                  onChange={(e) => {
                    const newAttrs = [...attributes];
                    newAttrs[index].type = e.target.value;
                    setAttributes(newAttrs);
                  }}
                  className="um-select-full"
                  style={{ flex: 1 }}
                >
                  <option value="text">text</option>
                  <option value="number">number</option>
                  <option value="date">date</option>
                </select>
                <button 
                  type="button" 
                  className="um-btn-sm um-btn-delete"
                  onClick={() => removeAttribute(index)}
                >
                  ×
                </button>
              </div>
            ))}
          </div>

          <div className="um-modal-actions">
            <button type="button" className="um-btn um-btn-secondary" onClick={() => setShowCreateCustomerModal(false)}>
              CANCEL
            </button>
            <button type="submit" className="um-btn um-btn-primary">
              SAVE
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CreateCustomerModal;